<template>
  <div class="padding-block-1">
    <LoginForm v-if="!isLoggedIn"/>
  </div>
</template>

<script>
import LoginForm from "../components/Form/LoginForm";
import store from "../store";
import router from "../router";

export default {
  name: "Connexion",
  components: {LoginForm},
  async created() {
    if(store.state.token) {
      await store.dispatch('AutoLogin')
    }
  },
  computed : {
    isLoggedIn() {
      if (store.state.token && store.state.user) return true
      return false
    },
  },
  watch : {
    isLoggedIn: function () {
      router.push('/mes-evenements')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>